import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  const [selectedAction, setSelectedAction] = useState('');

  const actionOptions = [
    { value: '', label: 'Select bulk action...' },
    { value: 'activate', label: 'Activate Users' },
    { value: 'deactivate', label: 'Deactivate Users' },
    { value: 'change-role', label: 'Change Role' },
    { value: 'send-email', label: 'Send Email' },
    { value: 'export', label: 'Export Data' },
    { value: 'delete', label: 'Delete Users' }
  ];

  const handleApply = () => {
    if (selectedAction) {
      onBulkAction(selectedAction);
      setSelectedAction('');
    }
  };

  if (selectedCount === 0) return null;

  return (
    <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 mb-6 animate-slide-down">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-accent text-accent-foreground flex items-center justify-center font-semibold">
            {selectedCount}
          </div>
          <div>
            <p className="font-medium text-foreground">
              {selectedCount} {selectedCount === 1 ? 'user' : 'users'} selected
            </p>
            <p className="text-sm text-muted-foreground">Choose an action to apply</p>
          </div>
        </div>

        <div className="flex items-center gap-3 flex-1 max-w-md">
          <Select
            options={actionOptions}
            value={selectedAction}
            onChange={setSelectedAction}
            placeholder="Select action..."
            className="flex-1"
          />
          <Button
            variant="default"
            onClick={handleApply}
            disabled={!selectedAction}
            iconName="Check"
            iconPosition="left"
          >
            Apply
          </Button>
          <Button
            variant="ghost"
            onClick={onClearSelection}
            iconName="X"
            size="icon"
            aria-label="Clear selection"
          />
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;